/**
 * Lumbazzi Website Tracker
 *
 * Captures visitor behavior and links to CRM profiles.
 * Install: Add to Shopify theme assets, include in theme.liquid before </body>
 *
 * Usage:
 *   lzTrack('event_name', { custom: 'data' })
 *   lzGetVisitorId()   - Returns persistent visitor ID
 *   lzGetSessionId()   - Returns current session ID
 *   lzGetAttribution() - Returns UTM attribution data
 */

(function() {
    'use strict';

    // ============================================================
    // CONFIGURATION
    // ============================================================

    // Production CRM endpoint
    var CRM_URL = 'https://lumbazzi-coaching-production.up.railway.app';

    // ============================================================
    // VISITOR & SESSION ID MANAGEMENT
    // ============================================================

    function generateId() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0;
            var v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    // Visitor ID - persists forever in localStorage
    var visitorId = localStorage.getItem('lz_visitor_id');
    if (!visitorId) {
        visitorId = 'vis_' + generateId();
        localStorage.setItem('lz_visitor_id', visitorId);
    }

    // Session ID - new each browser session
    var sessionId = sessionStorage.getItem('lz_session_id');
    if (!sessionId) {
        sessionId = 'ses_' + generateId();
        sessionStorage.setItem('lz_session_id', sessionId);
    }

    // ============================================================
    // UTM ATTRIBUTION CAPTURE
    // ============================================================

    function captureAttribution() {
        var params = new URLSearchParams(window.location.search);
        var attribution = {};

        // UTM parameters
        var utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
        utmParams.forEach(function(param) {
            var value = params.get(param);
            if (value) {
                attribution[param] = value;
            }
        });

        // Store first-touch attribution (only if not already set)
        var existingAttribution = localStorage.getItem('lz_attribution');
        if (!existingAttribution && Object.keys(attribution).length > 0) {
            attribution.captured_at = new Date().toISOString();
            attribution.landing_page = window.location.pathname;
            localStorage.setItem('lz_attribution', JSON.stringify(attribution));
        }

        // Also store last-touch (always update)
        if (Object.keys(attribution).length > 0) {
            attribution.captured_at = new Date().toISOString();
            attribution.landing_page = window.location.pathname;
            localStorage.setItem('lz_attribution_last', JSON.stringify(attribution));
        }

        return attribution;
    }

    // Capture UTM on page load
    var currentAttribution = captureAttribution();

    // ============================================================
    // CORE TRACKING FUNCTION
    // ============================================================

    function track(eventType, data) {
        data = data || {};

        var event = {
            event_type: eventType,
            visitor_id: visitorId,
            session_id: sessionId,
            timestamp: new Date().toISOString(),
            page_url: window.location.href,
            page_path: window.location.pathname,
            referrer: document.referrer || null,
            user_agent: navigator.userAgent,
            payload: data
        };

        // Add attribution if this is a session start or page view
        if (eventType === 'session.start' || eventType === 'page.viewed') {
            var attribution = JSON.parse(localStorage.getItem('lz_attribution') || '{}');
            if (Object.keys(attribution).length > 0) {
                event.attribution = attribution;
            }
        }

        // Send using beacon (non-blocking) or fall back to fetch
        var endpoint = CRM_URL + '/api/events';
        var payload = JSON.stringify(event);

        if (navigator.sendBeacon) {
            navigator.sendBeacon(endpoint, payload);
        } else {
            fetch(endpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: payload,
                keepalive: true
            }).catch(function(err) {
                console.warn('[LZ Tracker] Failed to send event:', err);
            });
        }

        // Log in development
        if (CRM_URL.indexOf('localhost') !== -1) {
            console.log('[LZ Tracker]', eventType, data);
        }
    }

    // ============================================================
    // AUTO-TRACKING: PAGE VIEWS & SESSION START
    // ============================================================

    // Track session start (only once per session)
    var sessionStarted = sessionStorage.getItem('lz_session_started');
    if (!sessionStarted) {
        track('session.start', {
            landing_page: window.location.pathname,
            referrer: document.referrer || null
        });
        sessionStorage.setItem('lz_session_started', 'true');
    }

    // Track page view
    track('page.viewed', {
        title: document.title
    });

    // ============================================================
    // SHOPIFY-SPECIFIC HELPERS
    // ============================================================

    // Get Shopify customer ID if logged in
    function getShopifyCustomerId() {
        // Method 1: Shopify Analytics object
        if (window.__st && window.__st.cid) {
            return 'gid://shopify/Customer/' + window.__st.cid;
        }
        // Method 2: Customer meta tag (if added to theme)
        var metaTag = document.querySelector('meta[name="shopify-customer-id"]');
        if (metaTag && metaTag.content) {
            return metaTag.content;
        }
        // Method 3: Data attribute on body (if added to theme)
        var body = document.body;
        if (body.dataset && body.dataset.customerId) {
            return body.dataset.customerId;
        }
        return null;
    }

    // ============================================================
    // EXPOSE GLOBAL API
    // ============================================================

    window.lzTrack = track;

    window.lzGetVisitorId = function() {
        return visitorId;
    };

    window.lzGetSessionId = function() {
        return sessionId;
    };

    window.lzGetAttribution = function() {
        return JSON.parse(localStorage.getItem('lz_attribution') || '{}');
    };

    window.lzGetShopifyCustomerId = getShopifyCustomerId;

    // Initialization log
    if (CRM_URL.indexOf('localhost') !== -1) {
        console.log('[LZ Tracker] Initialized', {
            visitor_id: visitorId,
            session_id: sessionId,
            attribution: currentAttribution
        });
    }

})();